import { warn } from "@swivl-mono/helpers";
import { VarDef, VarDefinition, VarKey } from "@swivl-mono/types";
import { SelectableOption } from "libs/ui/src/Shared/Shared";

export default class VarsModel {
  static _tagInputVariables: { id: string; display: string }[] = [];
  static _tagInputLoaded: boolean = false;
  static _selectableOptions: SelectableOption[] = [];
  static getTagInputVariables() {
    if (!VarsModel._tagInputLoaded) {
      VarsModel._tagInputVariables = Object.values(VarDef).map((key: VarDefinition) => ({
        id: key.varKey,
        display: `${key.type} - ${key.displayName}`,
      }));
      VarsModel._tagInputLoaded = true;
    }
    return VarsModel._tagInputVariables;
  }
  static inputProvider(id: string, display: string): string {
    if (id.indexOf("#*[")) {
      // remove everything withing brackets
      id = id.replace(/\[.*?\]/g, "");
    }
    return VarDef[id as VarKey] ? VarDef[id as VarKey]!.displayName : id;
  }

  static replaceVariableNameInString(str: string, prepend?: string, append?: string) {
    // const stringOG = String(str);
    if (!str) {
      return "";
    }
    if (str.indexOf("#*") === -1) {
      return str;
    }
    let mark = 0;
    while (str.indexOf("#*") !== -1 && mark < 3000) {
      const indexStart = str.indexOf("#*");
      const indexEnd = str.indexOf("*#");
      if (indexEnd < indexStart) {
        warn("improper setup for variables");
        str = str.replace("#*", "");
        str = str.replace("*#", "");
      } else {
        const variableId = str.substring(indexStart, indexEnd + 2);
        let replacement = VarsModel.nameForVariable(variableId);
        if (prepend && append) {
          replacement = prepend + replacement + append;
        }
        str = str.replace(variableId, replacement);
      }
      mark++;
    }
    if (mark >= 2999) {
      warn("Improper parse in replaceVariableNameInString", str);
    }
    return str;
  }

  static nameForVariable(variableId: string) {
    const varIdCleaned = variableId.replace("#*", "").replace("*#", "");
    if (VarDef[varIdCleaned as VarKey]) {
      const variable = VarDef[varIdCleaned as VarKey];
      return `${variable!.type} - ${variable!.displayName}`;
    }
    warn("No variable found for mk II", variableId);
    return varIdCleaned;
  }

  static variableOptions(
    skipUserId?: boolean,
    skipLastUserInput?: boolean,
    addMarkup?: boolean,
    includeURLPath?: boolean,
    skipNonUserVariables?: boolean,
  ): SelectableOption[] {
    if (!VarsModel._selectableOptions.length) {
      VarsModel._selectableOptions = Object.values(VarDef).map((key: VarDefinition) => ({
        id: key.varKey,
        label: key.type + " - " + key.displayName,
        value: key.varKey,
      }));
    }

    if (skipUserId || skipLastUserInput || skipNonUserVariables) {
      VarsModel._selectableOptions = VarsModel._selectableOptions.filter((option) => {
        if (option.value === VarKey.UserId && skipUserId) {
          return false;
        }
        if (option.value === VarKey.UserLastInput && skipLastUserInput) {
          return false;
        }
        if (!option.value.includes("User:") && skipNonUserVariables) {
          return false;
        }
        return true;
      });
    }
    return VarsModel._selectableOptions;
  }
}
